<template>
    <div class="business">
        <div class="headTitle">
            <div class="shadowTxt">OPERATION</div>
            <div class="title">商业运营</div>
            <div class="text">
                集商业开发及商业运营管理于一体，致力于打造突破业态边界、颠覆传统，引领全新的汽车服务模式和商业结合的商业品类品牌，通过商业模式创新，将汽车产业与商业、科技充分融合，以运营换流量，以服务强运营，满足消费者汽车体验和娱乐休闲消费的双重目的。
            </div>
        </div>
        <div class="businessBox">
            <div class="part">
                <div class="busImg">
                    <img src="../../assets/images/business3.png" alt="">
                </div>
                <div class="busTxt">天津西青·爱情广场</div>
                <div class="sTxt">AIQING GUANGCHANG</div>
            </div>
            <div class="part">
                <div class="busImg">
                    <img src="../../assets/images/business2.png" alt="">
                </div>
                <div class="busTxt">河北保定·爱情广场</div>
                <div class="sTxt">AIQING GUANGCHANG</div>
            </div>
            <div class="part">
                <div class="busImg">
                    <img src="../../assets/images/business1.png" alt="">
                </div>
                <div class="busTxt">重庆永川·爱情广场</div>
                <div class="sTxt">AIQING GUANGCHANG</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    metaInfo: {
        title: '商业运营-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
}
</script>
<style scoped lang='less'>
img{
    width: 100%;
}
.headTitle{
    padding: 20px 15px 7px 15px;
    background: #fff;
    .shadowTxt{
        font-size: 40px;
        line-height: 47px;
        color: #F8F8F8;
        font-family: 'DIN Alternate Bold';
        font-weight: bold;
    }
    .title{
        color: #222;
        font-size: 18px;
        line-height: 25px;
        font-family: '苹方-简 中黑体';
        font-weight: 600;
        margin-top: -28px;
    }
    .text{
        color: #666666;
        font-size: 13px;
        line-height: 20px;
        font-family: '苹方-简 常规体';
        margin-top: 9px;
    }
}
.businessBox{
    padding-top: 21px;
    .part{
        width: 100%;
        position: relative;
        .busTxt{
            font-family: 'YouSheBiaoTiHei';
            font-size: 20px;
            line-height: 26px;
             color: #fff;
             position: absolute;
             top: 54px;
             left: 104px;
        }
        .sTxt{
            font-family: 'YouSheBiaoTiHei';
            font-size: 16px;
            line-height: 21px;
            color: #fff;
            letter-spacing: 1.07px;
            opacity: 0.6;
            position: absolute;
            top: 85px;
            left: 83px;
        }
    }
}
</style>